<template>
  <div class="widget-card-content">
    <h2 class="content-title">{{title}}</h2>

    <div v-if="!isLoading && stat" class="widget-card-stat">
      <div class="widget-card-stat-title-box">
        <div v-if="stat.title" class="widget-card-stat-title">
          {{stat.title}}
        </div>
        <div v-if="stat.helpText" class="widget-stat-helper">
          <b-tooltip :label="stat.helpText"
                     :position="getTooltipPosition()"
                     class="is-gray widget-stat-helper-tooltip"
                     type="is-info"
                     size="is-small"
                     animated
                     multilined>
            <b-icon pack="fa" size="is-small" icon="question-circle">
            </b-icon>
          </b-tooltip>
        </div>
      </div>
      <ul
          v-if="stat.items"
          class="widget-card-stat-list">
        <li
            v-for="(item, index) in stat.items"
            :key="index"
        >
          <span><b>{{item.number.toLocaleString('en-US')}}</b> {{item.text}}</span>
        </li>
      </ul>
    </div>

    <div v-if="!isLoading && warning" class="warning-content bordered">
      <h3 v-if="warning.title" class="warning-content-title bold">
        {{warning.title}}
      </h3>
      <p
          v-if="warning.text[viewer]"
          class="warning-content-text bold"
          v-html="getTextHtml(warning.text[viewer])"
      />
    </div>

    <div v-if="!isLoading && subtitleLink" class="content-subtitle-link">
      <b v-if="subtitleLink.subtitle">URL: </b>
      <a v-if="subtitleLink.link" target="_blank" class="text-url" :href="subtitleLink.link" >
        {{prepareUrl(subtitleLink.link)}}
      </a>
    </div>

    <p v-if="!isLoading && text" class="widget-card-description">{{text}}</p>

    <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>

export const WIDGET_CARD_TYPE_WARNING = 'WIDGET_CARD_TYPE_WARNING';

export default {
  name: 'WidgetCardCoBrandedPageSlot',
  props: {
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    warning: {
      title: {
        type: String,
        default: null,
      },
      text: {
        customer: {
          type: String,
          default: null,
        },
        partner: {
          type: String,
          default: null,
        },
      },
    },
    subtitleLink: {
      subtitle: {
        type: String,
        default: null,
      },
      link: {
        type: String,
        default: null,
      },
    },
    stat: {
      title: String,
      helpText: String,
      items: Array,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    viewer: {
      type: String,
      default: '',
    },
  },
  methods: {
    prepareUrl(url) {
      return url.replace(/^[a-z]+:\/\//i, '');
    },
    getTextHtml(text) {
      return text.replace(/\n/g, '<div class="widget-card-spacer"></div>');
    },
    getTooltipPosition() {
      const width = this.$store.state.windowWidth;
      if (width <= 480) {
        return 'is-bottom';
      }
      if (width <= 600) {
        return 'is-right';
      }
      if (width <= 1170) {
        return 'is-bottom';
      }
      return 'is-right';
    },
  },
};
</script>

<style lang="stylus" scoped>

.warning-content {
  margin-top: 30px;
  &.bordered {
    padding-left: 20px;
    border-left: #DE4B4B solid 3px;
    @media (max-width 480px) {
      border-width: 2px;
      padding-left: 16px;
    }
  }
  & .warning-content-title {
    font-size: 16px;
    line-height: 22.4px;
    color: #DE4B4B;
    margin: 0;
  }
  & .warning-content-text {
    color: #525F66;
  }
  & .bold {
    font-weight: 900;
  }
}

.content-subtitle-link  {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  margin-top: 22px;
  color: #056ED6;
  @media (max-width 1170px) {
    margin-top: 34px;
  }
  @media (max-width 768px) {
  }
  @media (max-width 747px) {
    margin-top: 32px;
  }
  @media (max-width 600px) {
    margin-top: 16px;
  }
  @media (max-width 480px) {
    margin-top: 12px;
  }
  & b {
    font-weight: 700;
    color: #525F66;
  }
  & a {
    word-break: break-all;
    font-weight: 500;
  }
}


.widget-card-stat {
  & .widget-card-stat-title-box {
    display: flex;
    width: calc(100% - 16px);
    color: #525F66;
    font-weight: 700;
    margin-top: 21px;
    @media (max-width 600px) {
      margin-top: 5px;
    }
    @media (max-width 480px) {
      margin-top: 21px;
    }
  }
  & .widget-card-stat-list {
    margin-top: 6px;
    & li {
      & span {
        font-weight: 500;
        color: #525F66;
        & b {
          font-size: 26px;
          font-weight: 900;
          line-height: 36.4px;
          color: #1C418C;
        }
      }
    }
  }
  & .widget-stat-helper-tooltip {
    &.b-tooltip.is-multiline.is-small:after {
      width: 166px;
      padding: 17px 16px;
      font-size: 16px;
      font-weight: 400;
      line-height: 22.4px;

    }
  }
}
</style>
